import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "intent", "size"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors } from '@flowio/react-theme';
import { Icon } from '@flowio/react-icon';
import React from 'react';

var getWidth = function getWidth(size) {
  switch (size) {
    case 'large':
      return '24px';

    case 'medium':
      return '18px';

    default:
      return '12px';
  }
};

var getColor = function getColor(intent) {
  switch (intent) {
    case 'negative':
      return colors.RED_300;

    case 'positive':
      return colors.GREEN_300;

    case 'primary':
      return colors.FLOW_BLUE_300;

    case 'warning':
      return colors.YELLOW_400;

    default:
      return colors.GRAY_500;
  }
};

var TagInputIcon = function TagInputIcon(_ref) {
  var children = _ref.children,
      intent = _ref.intent,
      size = _ref.size,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var rootStyles = /*#__PURE__*/css({
    width: getWidth(size),
    height: 'auto',
    marginLeft: '4px',
    marginRight: '4px',
    marginInlineStart: '4px',
    marginInlineEnd: '4px',
    color: getColor(intent)
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  return jsx(Icon, _extends({}, unhandledProps, {
    css: rootStyles
  }));
};

export default TagInputIcon;